export default function FaqJsonLd({ itemLinks, faqName }) {
  const schema = buildFaqSchema(itemLinks, faqName);
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema).replace(/</g, '\\u003c')
      }}
    />
  );
}

const buildFaqSchema = (itemLinks = [], faqName = '') => {
  const mainEntity = itemLinks
    .map((item) => {
      const question = stripHtml(
        item?.section_content?.alt_title || item?.title || ''
      );

      // Note that Google allows some HTML tags, but since we destroy all '<'
      // at the last step, we may as well strip all HTML for now.
      const answer = stripHtml(item?.section_content?.content?.trim() || '');

      if (!question || !answer) {
        return null;
      }

      return {
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer
        }
      };
    })
    .filter(Boolean);

  if (!mainEntity.length) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    name: stripHtml(faqName) || 'Frequently Asked Questions',
    mainEntity
  };
};

const stripHtml = (value = '') => value.replace(/<[^>]+>/g, ' ').trim();
